/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetAllocationItem } from './AssetAllocationItem';
import {
    AssetAllocationItemFromJSON,
    AssetAllocationItemFromJSONTyped,
    AssetAllocationItemToJSON,
} from './AssetAllocationItem';

/**
 * 
 * @export
 * @interface AssetAllocation
 */
export interface AssetAllocation {
    /**
     * 
     * @type {string}
     * @memberof AssetAllocation
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetAllocation
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetAllocation
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof AssetAllocation
     */
    nrOfHoldings?: number;
    /**
     * 
     * @type {Array<AssetAllocationItem>}
     * @memberof AssetAllocation
     */
    items: Array<AssetAllocationItem>;
}

/**
 * Check if a given object implements the AssetAllocation interface.
 */
export function instanceOfAssetAllocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function AssetAllocationFromJSON(json: any): AssetAllocation {
    return AssetAllocationFromJSONTyped(json, false);
}

export function AssetAllocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetAllocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sId': json['s_id'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'nrOfHoldings': !exists(json, 'nr_of_holdings') ? undefined : json['nr_of_holdings'],
        'items': ((json['items'] as Array<any>).map(AssetAllocationItemFromJSON)),
    };
}

export function AssetAllocationToJSON(value?: AssetAllocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's_id': value.sId,
        'symbol': value.symbol,
        'description': value.description,
        'nr_of_holdings': value.nrOfHoldings,
        'items': ((value.items as Array<any>).map(AssetAllocationItemToJSON)),
    };
}

